// ===================================================
// RELATÓRIO DE MOVIMENTAÇÕES
// ===================================================
function renderRelMov(){
  const hoje = today();
  const ini = document.getElementById('rm-ini')?.value || toLocalISODate(new Date(new Date().getFullYear(),new Date().getMonth(),1));
  const fim = document.getElementById('rm-fim')?.value || hoje;
  const filtroTipo = document.getElementById('rm-tipo')?.value||'';
  if(document.getElementById('rm-ini')) document.getElementById('rm-ini').value=ini;
  if(document.getElementById('rm-fim')) document.getElementById('rm-fim').value=fim;

  let lancamentos = DB.get('lancamentos').filter(l=>l.data>=ini&&l.data<=fim);
  if(filtroTipo) lancamentos=lancamentos.filter(l=>l.tipo===filtroTipo);
  lancamentos.sort((a,b)=>b.data>a.data?1:-1);

  const entradas = lancamentos.filter(l=>l.tipo==='entrada');
  const saidas = lancamentos.filter(l=>l.tipo==='saida');
  const totalEnt = entradas.reduce((s,l)=>s+(l.valor||0),0);
  const totalSai = saidas.reduce((s,l)=>s+(l.valor||0),0);
  const saldo = totalEnt - totalSai;

  const cardsEl = document.getElementById('rm-cards');
  if(cardsEl) cardsEl.innerHTML=[
    {label:'Entradas',val:fmtMoney(totalEnt),icon:'↑',color:'#00d4aa'},
    {label:'Saídas',val:fmtMoney(totalSai),icon:'↓',color:'#f06595'},
    {label:'Saldo',val:fmtMoney(saldo),icon:'=',color:saldo>=0?'#6c63ff':'#f06595'},
    {label:'Lançamentos',val:lancamentos.length,icon:'📌',color:'#74c0fc'},
  ].map(c=>`<div class="card"><div class="card-icon" style="color:${c.color}">${c.icon}</div><div class="card-val" style="color:${c.color}">${c.val}</div><div class="card-label">${c.label}</div></div>`).join('');

  // Group by category for saídas
  const porCat = {};
  saidas.forEach(l=>{
    const cat=l.cat||'Outros';
    if(!porCat[cat]) porCat[cat]=0;
    porCat[cat]+=l.valor||0;
  });

  const el = document.getElementById('rm-content');
  if(!el) return;

  el.innerHTML = `
    ${Object.keys(porCat).length?`
    <div style="background:var(--surface);border:1px solid var(--border);border-radius:12px;padding:16px;margin-bottom:16px">
      <div style="font-weight:700;font-size:14px;margin-bottom:12px">Saídas por categoria</div>
      <div style="display:flex;flex-direction:column;gap:8px">
        ${Object.entries(porCat).sort((a,b)=>b[1]-a[1]).map(([cat,val])=>{
          const pct = totalSai>0?Math.round(val/totalSai*100):0;
          return `<div>
            <div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:3px">
              <span>${cat}</span><span><b>${fmtMoney(val)}</b> <span style="color:var(--muted)">(${pct}%)</span></span>
            </div>
            <div style="background:var(--border);border-radius:4px;height:5px">
              <div style="width:${pct}%;background:#f06595;height:5px;border-radius:4px"></div>
            </div>
          </div>`;
        }).join('')}
      </div>
    </div>`:''}

    <div style="background:var(--surface);border:1px solid var(--border);border-radius:12px;overflow:hidden">
      <table style="width:100%;border-collapse:collapse;font-size:13px">
        <thead><tr style="background:var(--bg);border-bottom:2px solid var(--border)">
          <th style="padding:10px 14px;text-align:left">Data</th>
          <th style="padding:10px;text-align:left">Descrição</th>
          <th style="padding:10px;text-align:left">Categoria</th>
          <th style="padding:10px;text-align:left">Origem</th>
          <th style="padding:10px;text-align:right">Valor</th>
          <th style="padding:10px;text-align:center">Tipo</th>
        </tr></thead>
        <tbody>${lancamentos.length?lancamentos.map(l=>`<tr style="border-bottom:1px solid var(--border)">
          <td style="padding:10px 14px;white-space:nowrap">${fmtData(l.data)}</td>
          <td style="padding:10px;font-size:12px">${escapeHtml(l.desc||'—')}</td>
          <td style="padding:10px;font-size:12px;color:var(--muted)">${l.cat||'—'}</td>
          <td style="padding:10px;font-size:11px;color:var(--muted)">${l.origem==='extrato'?'📥 Extrato':'Manual'}</td>
          <td style="padding:10px;text-align:right;font-weight:700;color:${l.tipo==='entrada'?'#00d4aa':'#f06595'}">${l.tipo==='entrada'?'+':'-'}${fmtMoney(l.valor||0)}</td>
          <td style="padding:10px;text-align:center"><span style="font-size:11px;padding:2px 8px;border-radius:20px;background:${l.tipo==='entrada'?'#00d4aa22':'#f0659522'};color:${l.tipo==='entrada'?'#00d4aa':'#f06595'}">${l.tipo==='entrada'?'Entrada':'Saída'}</span></td>
        </tr>`).join(''):`<tr><td colspan="6" style="padding:32px;text-align:center;color:var(--muted)">Nenhum lançamento no período</td></tr>`}
        </tbody>
        ${lancamentos.length?`<tfoot><tr style="background:var(--bg);border-top:2px solid var(--border);font-weight:700">
          <td colspan="4" style="padding:10px 14px">Total no período</td>
          <td style="padding:10px;text-align:right;color:${saldo>=0?'#00d4aa':'#f06595'}">${saldo>=0?'+':'-'}${fmtMoney(Math.abs(saldo))}</td>
          <td></td>
        </tr></tfoot>`:''}
      </table>
    </div>
  `;
}

